import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

export function useLots() {
  return useQuery({
    queryKey: ['lots', 'list'],
    queryFn: () => api.get('/lots'),
    staleTime: 60_000,
  });
}

export function useLot(lotNumber) {
  return useQuery({
    queryKey: ['lots', 'detail', lotNumber],
    queryFn: () => api.get(`/lots/${lotNumber}`),
    staleTime: 60_000,
    enabled: lotNumber != null && !Number.isNaN(Number(lotNumber)),
  });
}

export function useUpdateLotAcquisition() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ lotNumber, body }) =>
      api.put(`/lots/${lotNumber}/acquisition`, body),
    onSuccess: (_data, { lotNumber }) => {
      qc.invalidateQueries({ queryKey: ['lots', 'list'] });
      qc.invalidateQueries({ queryKey: ['lots', 'detail', Number(lotNumber)] });
      qc.invalidateQueries({ queryKey: ['lots', 'detail', String(lotNumber)] });
    },
  });
}
